import React, { useState, useEffect, useCallback } from "react";
import { caApi } from "../../../../../backend_urls/caApi";
import InlineSpinner from "../../../../../components/loaders/InlineSpinner";
// import AutoClosePopup from "../../../../../components/popups/AutoClosePopup";
import ActionButtons from "../../../../../utils/ActionButtons";
import FileUpload from "../../../../../components/reusable/FileUpload";
import ModalPopup from "../../../../../components/popups/DefaultPopUp";
import "../../../../../css/pages/ca_pages/models/ShowClientBusinesses.css";

const ShowClientBusinesses = ({ clientId, onClose, onSubmit }) => {
    const [clientBusinesses, setClientBusinesses] = useState([]);
    const [businessLoading, setBusinessLoading] = useState(false);
    // const [open, setOpen] = useState(false);

    const [uploadModal, setUploadModal] = useState(false);
    const [selectedBusiness, setSelectedBusiness] = useState(null);
    const [uploadType, setUploadType] = useState(null); // "invoice" | "excel"

    const [invoiceApprovalPopup, setInvoiceApprovalPopup] = useState(false);

    const fetchClientBusiness = useCallback(async () => {
        try {
            setBusinessLoading(true);
            const response = await caApi.getClientBusiness(clientId);
            setClientBusinesses(response.data || []);
        } catch (e) { console.error("Error fetching client's business info:", e);
        } finally { setBusinessLoading(false); }
    }, [clientId]);
    useEffect(() => {
        if (clientId) { fetchClientBusiness(); }
    }, [clientId, fetchClientBusiness] );

    const handleEditBusiness = (businessId) => { console.log("Edit business with ID:", businessId); };

    const handleBulkApprove = (businessId) => {
        if (!businessId) return;
        setSelectedBusiness(businessId);
        setInvoiceApprovalPopup(true);
    };
    const confirmBulkApprove = async () => {
        try {
            if (!selectedBusiness) return;
            // setLoading(true);
            await caApi.bulkApproveClientInvoice(selectedBusiness);
            fetchClientBusiness();
        } catch (e) { console.log("Error Occured:", e); }
    }

    const handleUpload = (businessId, type) => {
        setSelectedBusiness(businessId);
        setUploadType(type);
        setUploadModal(true);
    };

    const handleFileUpload = async (file) => {
        try {
            if (!selectedBusiness) {
                alert("No business selected.");
                return;
            }
            onSubmit({ businessId: selectedBusiness, file, uploadType });
            alert("File uploaded successfully.");
        } catch (error) {
            console.error("Error uploading file:", error);
            alert("Error uploading file.");
        } finally {
            setUploadModal(false);
            setSelectedBusiness(null);
            setUploadType(null);
        }
    };

    const dropDownOptions = (businessId) => ([
        {
            label: "Edit Business details",
            onClick: () => { handleEditBusiness(businessId); }
        },
        {
            label: "Approve all eligible invoices",
            onClick: () => { handleBulkApprove(businessId); }
        },
        {
            label: "Download Excel Report",
            onClick: async () => {await caApi.generateBusinessInvoiceExcelFile(businessId);},
        },
        {
            label: "Upload Excel Report",
            onClick: () => handleUpload(businessId, "excel")
        },
    ]);

    const uploadConfig = {
        invoice: { label: "Upload Invoice File", acceptType: "invoice" },
        excel:   { label: "Upload Excel Report", acceptType: "excel" },
    };

    return ( businessLoading ? <InlineSpinner /> : (
        <>
            <div className="client-businesses-container">
                {clientBusinesses.length > 0 ? (
                    <table className="client-businesses-table">
                        <thead>
                            <tr>
                                <th>Business</th>
                                <th>GSTIN</th>
                                <th>Created</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clientBusinesses.map((business) => (
                                <tr key={business.id}>
                                    <td>
                                        <div className="business-name-cell">
                                            <strong>
                                                {business.business_name}
                                            </strong>

                                            {business.business_website_url && (
                                                <small>
                                                    {business.business_website_url}
                                                </small>
                                            )}
                                        </div>
                                    </td>

                                    <td><code>{business.gstin}</code></td>

                                    <td>
                                        {new Date(
                                            business.created_at
                                        ).toLocaleDateString()}
                                    </td>

                                    <td>
                                        <span
                                            className={`status-badge ${
                                                business.is_active
                                                    ? "active"
                                                    : "inactive"
                                            }`}
                                        >
                                            {business.is_active ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                    <td>
                                        <ActionButtons
                                            actions = {[
                                                {
                                                    buttonType: "view",
                                                    customName: "Invoice Upload",
                                                    onClick: () => handleUpload(business.id, "invoice"),
                                                },
                                                {
                                                    buttonType: "moreOptions",
                                                    dropdownOptions: dropDownOptions(business.id)
                                                }
                                            ]}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <div className="empty-business-state">
                        No businesses found for this client.
                    </div>
                )}
            </div>

            {/* Add business creation logic here */}
            {uploadModal && (
                <FileUpload
                    label = { uploadConfig[uploadType].label }
                    acceptType = { uploadConfig[uploadType].acceptType }
                    maxFiles = { 1 }
                    maxSizeMB = { 10 }
                    onSave = { handleFileUpload }
                    onClose = { () => {
                        setUploadModal(false);
                        setSelectedBusiness(null);
                        setUploadType(null);
                    }}
                />
            )}

            <ModalPopup
                isOpen     = { invoiceApprovalPopup }
                onClose    = { () => {
                    setInvoiceApprovalPopup(false);
                    setSelectedBusiness(null);
                }}
                title      = "Bulk Approval Confirmation"
                subtext    = "Are you sure you want to Approve all the Invoices associated with this business?"
                actionText = "Approve All"
                onAction   = { confirmBulkApprove }
            />
        </>
    ));
};

export default ShowClientBusinesses;
